// The default board statuses and priorities are stored in English
// (server/models/Board.js) and tasks refer to them by that text, so they are
// never changed in the data - only shown in the user's language. Labels a
// user typed themselves are shown as they are.
const DEFAULT_LABEL_KEYS = {
  "Not Started": "defaults.status.notStarted",
  "In Progress": "defaults.status.inProgress",
  Completed: "defaults.status.completed",
  Stuck: "defaults.status.stuck",
  Pending: "defaults.status.pending",
  Urgent: "defaults.priority.urgent",
  High: "defaults.priority.high",
  Medium: "defaults.priority.medium",
  Low: "defaults.priority.low",
  Trivial: "defaults.priority.trivial",
};

// Pass t from useTranslation(), so the component re-renders on language change
export const translateLabel = (label, t) =>
  DEFAULT_LABEL_KEYS[label] ? t(DEFAULT_LABEL_KEYS[label]) : label;
